export default __webpack_public_path__ + "static/media/error-404.46247d01.svg";